import { JsonObject, JsonProperty } from 'json2typescript';

@JsonObject('thumbnail')
export default class Thumbnail {
  constructor() {
    this.resourceUri = undefined;
    this.resourceFileName = undefined;
    this.alternativeText = undefined;
  }

  @JsonProperty('resource_uri')
  public resourceUri?: string;

  @JsonProperty('resource_file_name')
  public resourceFileName?: string;

  @JsonProperty('alternative_text')
  public alternativeText?: string;
}
